<template>
    <div class="empty-bg">
        <img
            src="../../../static/images/empty.png"
            width="352"
            height="262"
            alt=""
            class="empty-img"
        />
        <div class="empty-text">您所访问的系统已暂停服务...</div>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {}
        },

        methods: {},
    }
</script>

<style lang="less" type="text/less" scoped>
    .empty-bg {
        width: 100%;
        height: 100vh;
        background: url('../../../static/images/empty-bg.png') center bottom no-repeat;
        background-size: cover;
        width: 100vw;
        height: 100vh;
        /* display: flex; */
        justify-content: center;

        .empty-img {
            margin-bottom: 20px;
            /* margin-left: 400px; */
            margin-top: 200px;
        }

        .empty-text {
            font-size: 32px;
            /* font-weight: bold; */
            color: #666;
            letter-spacing: 2px;
            /* margin-top: 265px; */
        }
    }
</style>
